export function resolveFinalSale(finalSale, t) {
  let finalSaleText = null;

  if (finalSale) {
    finalSaleText = <span>{t("final-sale-label")}</span>;
  }

  return finalSaleText;
}
